import { graphic } from "../../Graphic";
import { Row } from "../../entity/row/Row";
import { containerEvents } from "../../ContainerEvents";
import { Container } from 'pixi.js';
import { RowService } from "../../entity/row/RowService";

export class RowsPlaceholder {

    constructor() {
        this.isStarted = false;
        this.rows = [];
        this.graphicItem = RowService.createGraphicItem(0, 0);
        this.graphicItem.position = containerEvents.mouseCoords;
        this.prevCount = { x: 0, y: 0 };
        graphic.container.addChild(this.graphicItem);
    }

    getStatement() {
        return this.rows;
    }

    start(position) {
        this.isStarted = true;
        this.startPosition = position;
    }

    stop() {
        this.clearItems();
        this.isStarted = false;
    }

    destroy() {
        graphic.container.removeChild(this.graphicItem);
        this.stop();
    }

    move(position) {
        if (this.isStarted) {
            const dist = {
                x: position.x - this.startPosition.x,
                y: position.y - this.startPosition.y
            };
            const countItems = {
                x: Math.round(dist.x / ((Row.size + Row.margin) * 2)),
                y: Math.round(dist.y / ((Row.size + Row.margin) * 2))
            };
            this.drawItems({
                x: Math.sign(countItems.x) === -1 ? countItems.x - 1 : countItems.x + 1,
                y: Math.sign(countItems.y) === -1 ? countItems.y - 1 : countItems.y + 1
            });
        } else {
            this.graphicItem.x = position.x;
            this.graphicItem.y = position.y;
        }
    }

    drawItems(count) {
        if (this.prevCount.x === count.x && this.prevCount.y === count.y) return;
        this.prevCount = count;

        this.clearItems();
        let countY = count.y;

        while(countY  !== 0) {
            if (Math.sign(countY) === 1) countY--;
            else if (Math.sign(countY) === -1) countY++;

            let container = new Container();
            container.position.x = this.startPosition.x;
            container.position.y = this.startPosition.y + (countY * (Row.size + Row.margin) * 2);

            const graphicItems = RowService.createGraphicItems(count.x);
            const row = new Row({
                container,
                graphicItems,
                label: RowService.generateLabel(Math.abs(countY))
            });
            row.draw();
            this.rows.push(row);
        }
    }

    clearItems() {
        this.prevCount = { x: 0, y: 0 };
        this.rows.forEach(row => row.destroy());
        this.rows = [];
    }
}